import React from 'react'

class Paginate extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      start: 1,
      lastLink: null,
      perPage: 10
    }
  }

  pagination() {
    let props = this.props
    let pages = []
    let currentPage = props.currentPage
    let start = this.state.start // start of the application
    let lastLink = this.state.lastLink

    for (let i = start; i <= lastLink; i++) {
      let classNames = currentPage === i ? 'page-item active' : 'page-item'

      pages.push(<li key={i} className={classNames}><a href="page?" className="page-link" onClick={props.handler(i)}>{i}</a></li>)
    }

    return pages
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.currentPage !== this.props.currentPage) {

      // check if current page is divisible to perpage
      if (prevProps.currentPage % prevState.perPage === 0) {

        // if current page not 1
        if(this.props.currentPage !== 1) {
          const sumOfCurrentPageAndPerPage = this.props.currentPage + this.state.perPage

          if (sumOfCurrentPageAndPerPage > this.state.lastLink) {
            this.setState({lastLink: this.props.pageCount})
          } else {
            this.setState({lastLink: sumOfCurrentPageAndPerPage})
          }

          // current page is the start of the set
          if (this.props.currentPage % this.state.perPage === 1) {
            this.setState({start: this.props.currentPage})
          }
        }
      }

      // if current page equals to 1
      if (this.props.currentPage === 1) {
        if (this.state.perPage > this.props.pageCount) {
          this.setState({lastLink: this.props.pageCount})
        } else {
          this.setState({start: this.props.currentPage})
          this.setState({lastLink: this.state.perPage})
        }
      }

    }
  }

  render() {
    const props = this.props

    return (
      <nav className="text-center">
        <ul className="pagination">
          <li className="page-item">
            <a className="page-link" href="prev" onClick={props.handler(props.prevUrl)}>Previous</a>
          </li>
          {this.pagination()}
          <li className="page-item">
            <a className="page-link" href="next" onClick={props.handler(props.nextUrl)}>Next</a>
          </li>
        </ul>
      </nav>
    )
  }
}

export default Paginate
